import React, { useState, Component } from 'react';
import { Link } from 'react-router-dom';
import { Share2, Edit2, ExternalLink, X, Copy, Check, Twitter, Facebook, Linkedin, Mail, MapPin } from 'lucide-react';
export function DashboardHome() {
  const [showShareModal, setShowShareModal] = useState(false);
  const [copied, setCopied] = useState(false);
  const profileUrl = 'eaves.pro/marcuschen';
  const fullUrl = `https://${profileUrl}`;
  const handleCopy = () => {
    navigator.clipboard.writeText(fullUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <div className="p-8 max-w-4xl mx-auto" data-id="element-408">
      <h1 className="text-3xl font-serif font-semibold text-brand-dark mb-8" data-id="element-409">
        My Profile
      </h1>

      {/* Profile Preview Card */}
      <div className="bg-white rounded-2xl border border-brand-light shadow-sm overflow-hidden mb-8" data-id="element-410">
        <div className="p-6 bg-brand-light/30 flex flex-col items-center justify-center min-h-[300px]" data-id="element-411">
          {/* Mini Profile Preview */}
          <div className="w-full max-w-sm bg-white rounded-2xl shadow-premium overflow-hidden border border-brand-light" data-id="element-412">
            <div className="h-24 bg-gradient-to-r from-brand-sage via-brand-sandstoneBg to-brand-light relative" data-id="element-413">
              <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-brand-forest to-transparent" data-id="element-414"></div>
            </div>
            <div className="px-6 pb-6 -mt-12 relative z-10 flex flex-col items-center text-center" data-id="element-415">
              <div className="w-20 h-20 rounded-full border-4 border-white overflow-hidden shadow-sm mb-3 bg-white" data-id="element-416">
                <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop" alt="Marcus Chen" className="w-full h-full object-cover" data-id="element-417" />
              </div>
              <h3 className="text-lg font-serif font-semibold text-brand-dark mb-1" data-id="element-418">
                Marcus Chen
              </h3>
              <p className="text-xs text-brand-muted font-serif italic mb-3" data-id="element-419">
                Senior real estate advisor
              </p>

              <div className="flex flex-col items-center gap-2 w-full" data-id="element-420">
                <div className="flex gap-2" data-id="element-421">
                  <span className="text-[10px] font-medium bg-brand-offwhite border border-brand-light px-2 py-0.5 rounded-full text-brand-dark" data-id="element-422">
                    Zillow 4.9 ★
                  </span>
                  <span className="text-[10px] font-medium bg-brand-offwhite border border-brand-light px-2 py-0.5 rounded-full text-brand-dark" data-id="element-423">
                    Google 4.8 ★
                  </span>
                </div>
                <p className="text-[10px] text-brand-muted font-mono mt-1" data-id="element-424">
                  94109 · 94123 · 94117
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="p-6 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-brand-light" data-id="element-425">
          <div data-id="element-426">
            <h2 className="text-lg font-medium text-brand-dark" data-id="element-427">Marcus Chen</h2>
            <a href="/marcuschen" target="_blank" rel="noreferrer" className="text-sm text-brand-muted font-mono hover:text-brand-forest transition-colors" data-id="element-428">
              {profileUrl}
            </a>
          </div>
          <div className="flex items-center gap-3" data-id="element-429">
            <a href="/marcuschen" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 px-4 py-2 bg-brand-forest hover:bg-brand-forestHover text-white rounded-xl text-sm font-medium transition-colors shadow-sm" data-id="element-430">
              Preview
              <ExternalLink size={16} data-id="element-431" />
            </a>
            <button onClick={() => setShowShareModal(true)} className="inline-flex items-center gap-2 px-4 py-2 bg-white border border-brand-light hover:border-brand-forest/30 rounded-xl text-sm font-medium text-brand-dark transition-colors shadow-sm" data-id="element-432">
              <Share2 size={16} className="text-brand-muted" data-id="element-433" />
              Share
            </button>
            <Link to="/admin/edit" className="inline-flex items-center gap-2 px-4 py-2 bg-brand-offwhite border border-brand-light hover:bg-brand-sage rounded-xl text-sm font-medium text-brand-dark transition-colors" data-id="element-434">
              <Edit2 size={16} className="text-brand-muted" data-id="element-435" />
              Edit
            </Link>
          </div>
        </div>
      </div>

      {/* Make it yours Section */}
      <div className="bg-white rounded-2xl border border-brand-light shadow-sm p-6" data-id="element-436">
        <h2 className="text-xl font-serif font-medium text-brand-dark" data-id="element-437">
          Make it yours
        </h2>
        <p className="text-sm text-brand-muted mt-2 mb-6 max-w-2xl" data-id="element-438">
          The fundamentals are already set — your performance, reviews, and
          verification. These are the touches that are yours to add.
        </p>

        <div className="space-y-5" data-id="element-439">
          <div className="border-t border-brand-light pt-5 flex flex-col sm:flex-row sm:items-start justify-between gap-4" data-id="element-440">
            <div data-id="element-441">
              <h3 className="text-sm font-medium text-brand-dark" data-id="element-442">Photo</h3>
              <p className="text-sm text-brand-muted mt-1 max-w-md" data-id="element-443">
                A real headshot builds trust. We'll use your initials in a
                branded placeholder until you upload one.
              </p>
            </div>
            <button className="shrink-0 bg-brand-forest text-white text-sm font-medium px-4 py-2 rounded-lg hover:bg-brand-forestHover transition-colors" data-id="element-444">
              Upload photo
            </button>
          </div>

          <div className="border-t border-brand-light pt-5 flex flex-col sm:flex-row sm:items-start justify-between gap-4" data-id="element-445">
            <div data-id="element-446">
              <h3 className="text-sm font-medium text-brand-dark" data-id="element-447">Bio</h3>
              <p className="text-sm text-brand-muted mt-1 max-w-md" data-id="element-448">
                We've drafted a bio from your transaction history. Edit it, or
                write your own.
              </p>
            </div>
            <div className="shrink-0 flex gap-2" data-id="element-449">
              <button className="border border-brand-light rounded-lg px-3 py-1.5 text-sm text-brand-dark hover:bg-brand-offwhite transition-colors" data-id="element-450">
                View AI draft
              </button>
              <button className="border border-brand-light rounded-lg px-3 py-1.5 text-sm text-brand-dark hover:bg-brand-offwhite transition-colors" data-id="element-451">
                Write your own
              </button>
            </div>
          </div>

          <div className="border-t border-brand-light pt-5 flex flex-col sm:flex-row sm:items-start justify-between gap-4" data-id="element-452">
            <div data-id="element-453">
              <h3 className="text-sm font-medium text-brand-dark" data-id="element-454">
                Listings & Videos
              </h3>
              <p className="text-sm text-brand-muted mt-1 max-w-md" data-id="element-455">
                Showcase your listings and video portfolio. Choose from
                carousel, small card, or large card layouts. Paste a URL and
                we'll fetch the details automatically.
              </p>
            </div>
            <button className="shrink-0 border border-brand-light rounded-lg px-3 py-1.5 text-sm text-brand-dark hover:bg-brand-offwhite transition-colors" data-id="element-456">
              Add listings & videos
            </button>
          </div>

          <div className="border-t border-brand-light pt-5 flex flex-col sm:flex-row sm:items-start justify-between gap-4" data-id="element-457">
            <div data-id="element-458">
              <h3 className="text-sm font-medium text-brand-dark" data-id="element-459">
                Custom Links
              </h3>
              <p className="text-sm text-brand-muted mt-1 max-w-md" data-id="element-460">
                Add any links you want — intake forms, booking pages, resources,
                or anything else. Paste a URL and we'll fetch the details, or
                customize manually.
              </p>
            </div>
            <div className="shrink-0 flex gap-2" data-id="element-461">
              <button className="border border-brand-light rounded-lg px-3 py-1.5 text-sm text-brand-dark hover:bg-brand-offwhite transition-colors" data-id="element-462">
                Add custom link
              </button>
              <button className="border border-brand-light rounded-lg px-3 py-1.5 text-sm text-brand-dark hover:bg-brand-offwhite transition-colors" data-id="element-463">
                Use Eaves contact form
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Market Status Section */}
      <div className="bg-brand-sage/30 rounded-2xl border border-brand-sage p-6 mt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4" data-id="element-464">
        <div className="flex items-center gap-4" data-id="element-465">
          <div className="w-10 h-10 rounded-full bg-brand-sage flex items-center justify-center text-brand-forest shrink-0" data-id="element-466">
            <MapPin size={20} data-id="element-467" />
          </div>
          <div data-id="element-468">
            <h3 className="font-medium text-brand-dark" data-id="element-469">Market Status</h3>
            <p className="text-sm text-brand-muted mt-0.5" data-id="element-470">
              We will match sellers and buyers to you.
            </p>
          </div>
        </div>
        <a href="#" className="text-sm text-brand-forest font-medium hover:underline whitespace-nowrap" data-id="element-471">
          Learn details and help activate your market →
        </a>
      </div>

      {/* Share Modal */}
      {showShareModal && <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-50 flex items-center justify-center p-4" data-id="element-472">
          <div className="bg-white rounded-2xl p-6 max-w-md w-full shadow-2xl relative animate-in fade-in zoom-in-95 duration-200" data-id="element-473">
            <button onClick={() => setShowShareModal(false)} className="absolute top-4 right-4 p-2 text-brand-muted hover:text-brand-dark hover:bg-brand-offwhite rounded-full transition-colors" data-id="element-474">
              <X size={20} data-id="element-475" />
            </button>

            <h2 className="font-serif font-semibold text-xl text-brand-dark mb-6" data-id="element-476">
              Share your profile
            </h2>

            {/* Copy Link */}
            <div className="mb-6" data-id="element-477">
              <label className="block text-xs font-medium text-brand-muted uppercase tracking-wider mb-2" data-id="element-478">
                Copy Link
              </label>
              <div className="flex items-center gap-2" data-id="element-479">
                <div className="flex-1 bg-brand-offwhite border border-brand-light rounded-xl px-4 py-3 font-mono text-sm text-brand-dark truncate" data-id="element-480">
                  {fullUrl}
                </div>
                <button onClick={handleCopy} className="shrink-0 flex items-center gap-2 bg-brand-forest text-white px-4 py-3 rounded-xl font-medium hover:bg-brand-forestHover transition-colors" data-id="element-481">
                  {copied ? <Check size={18} data-id="element-482" /> : <Copy size={18} data-id="element-483" />}
                  {copied ? 'Copied!' : 'Copy'}
                </button>
              </div>
            </div>

            {/* QR Code */}
            <div className="mb-6 border-t border-brand-light pt-6" data-id="element-484">
              <label className="block text-xs font-medium text-brand-muted uppercase tracking-wider mb-4 text-center" data-id="element-485">
                Scan to visit profile
              </label>
              <div className="flex flex-col items-center" data-id="element-486">
                <div className="w-32 h-32 bg-white border-2 border-brand-light rounded-xl p-2 mb-4" data-id="element-487">
                  {/* Placeholder QR Code SVG */}
                  <svg viewBox="0 0 100 100" className="w-full h-full text-brand-dark" data-id="element-488">
                    <rect width="100" height="100" fill="none" data-id="element-489" />
                    <path d="M10,10 h20 v20 h-20 z M15,15 h10 v10 h-10 z" fill="currentColor" data-id="element-490" />
                    <path d="M70,10 h20 v20 h-20 z M75,15 h10 v10 h-10 z" fill="currentColor" data-id="element-491" />
                    <path d="M10,70 h20 v20 h-20 z M15,75 h10 v10 h-10 z" fill="currentColor" data-id="element-492" />
                    <rect x="40" y="10" width="10" height="10" fill="currentColor" data-id="element-493" />
                    <rect x="55" y="20" width="10" height="10" fill="currentColor" data-id="element-494" />
                    <rect x="10" y="40" width="10" height="10" fill="currentColor" data-id="element-495" />
                    <rect x="25" y="55" width="10" height="10" fill="currentColor" data-id="element-496" />
                    <rect x="40" y="40" width="20" height="20" fill="currentColor" data-id="element-497" />
                    <rect x="70" y="40" width="10" height="10" fill="currentColor" data-id="element-498" />
                    <rect x="85" y="55" width="10" height="10" fill="currentColor" data-id="element-499" />
                    <rect x="40" y="70" width="10" height="10" fill="currentColor" data-id="element-500" />
                    <rect x="55" y="85" width="10" height="10" fill="currentColor" data-id="element-501" />
                    <rect x="70" y="70" width="20" height="20" fill="currentColor" data-id="element-502" />
                  </svg>
                </div>
                <button className="text-sm font-medium text-brand-forest hover:text-brand-dark transition-colors" data-id="element-503">
                  Download QR
                </button>
              </div>
            </div>

            {/* Social Share */}
            <div className="border-t border-brand-light pt-6" data-id="element-504">
              <label className="block text-xs font-medium text-brand-muted uppercase tracking-wider mb-4" data-id="element-505">
                Share via
              </label>
              <div className="flex justify-between gap-2" data-id="element-506">
                <a href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(fullUrl + '?utm_source=twitter&utm_medium=social&utm_campaign=agent_share')}`} target="_blank" rel="noreferrer" className="flex flex-col items-center gap-2 group" data-id="element-507">
                  <div className="w-12 h-12 rounded-full bg-brand-offwhite border border-brand-light flex items-center justify-center group-hover:bg-brand-sage group-hover:border-brand-forest/30 transition-all" data-id="element-508">
                    <Twitter size={20} className="text-brand-dark" data-id="element-509" />
                  </div>
                  <span className="text-xs text-brand-muted group-hover:text-brand-dark" data-id="element-510">
                    X
                  </span>
                </a>

                <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(fullUrl + '?utm_source=facebook&utm_medium=social&utm_campaign=agent_share')}`} target="_blank" rel="noreferrer" className="flex flex-col items-center gap-2 group" data-id="element-511">
                  <div className="w-12 h-12 rounded-full bg-brand-offwhite border border-brand-light flex items-center justify-center group-hover:bg-brand-sage group-hover:border-brand-forest/30 transition-all" data-id="element-512">
                    <Facebook size={20} className="text-brand-dark" data-id="element-513" />
                  </div>
                  <span className="text-xs text-brand-muted group-hover:text-brand-dark" data-id="element-514">
                    Facebook
                  </span>
                </a>

                <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(fullUrl + '?utm_source=linkedin&utm_medium=social&utm_campaign=agent_share')}`} target="_blank" rel="noreferrer" className="flex flex-col items-center gap-2 group" data-id="element-515">
                  <div className="w-12 h-12 rounded-full bg-brand-offwhite border border-brand-light flex items-center justify-center group-hover:bg-brand-sage group-hover:border-brand-forest/30 transition-all" data-id="element-516">
                    <Linkedin size={20} className="text-brand-dark" data-id="element-517" />
                  </div>
                  <span className="text-xs text-brand-muted group-hover:text-brand-dark" data-id="element-518">
                    LinkedIn
                  </span>
                </a>

                <a href={`mailto:?subject=Check out my Eaves Pro profile&body=${encodeURIComponent('View my real estate performance, reviews, and active listings here: ' + fullUrl + '?utm_source=email&utm_medium=share&utm_campaign=agent_share')}`} className="flex flex-col items-center gap-2 group" data-id="element-519">
                  <div className="w-12 h-12 rounded-full bg-brand-offwhite border border-brand-light flex items-center justify-center group-hover:bg-brand-sage group-hover:border-brand-forest/30 transition-all" data-id="element-520">
                    <Mail size={20} className="text-brand-dark" data-id="element-521" />
                  </div>
                  <span className="text-xs text-brand-muted group-hover:text-brand-dark" data-id="element-522">
                    Email
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>}
    </div>;
}